import { axios_nomination } from '@/plugins/axios';
import configuration from '@/configurations';

class ConsumptionHistoryRepository {

  async getOrganizationStatisticsConsultedContacts(input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
      group_by,
      organization_id,
      user_id_list,
    } = input;

    const body = {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
    };

    if (group_by) {
      body.group_by = group_by;
    }

    const result = await axios_nomination
      .post(`${configuration.api_host}/v1/consumption-history/consulted_contacts/organizations/${organization_id}/statistics/sums`,
        body
      );

    return result.data;
  }

  async getUserStatisticsConsultedContacts(input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
      organization_id,
    } = input;

    const body = {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
    };
    const result = await axios_nomination
      .post(`${configuration.api_host}/v1/consumption-history/consulted_contacts/organizations/${organization_id}/users/statistics/sums`,
        body
      );

    return result.data;
  }

  async getOrganizationStatisticsConsultedAccounts(input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
      group_by,
      organization_id,
      user_id_list,
    } = input;

    const body = {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
    };

    if (group_by) {
      body.group_by = group_by;
    }

    const result = await axios_nomination
      .post(`${configuration.api_host}/v1/consumption-history/consulted_accounts/organizations/${organization_id}/statistics/sums`,
        body
      );

    return result.data;
  }

  async getUserStatisticsConsultedAccounts(input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
      organization_id,
    } = input;

    const body = {
      date_lower_boundary,
      date_upper_boundary,
      user_id_list,
    };

    const result = await axios_nomination
      .post(`${configuration.api_host}/v1/consumption-history/consulted_accounts/organizations/${organization_id}/users/statistics/sums`,
        body
      );

    return result.data;
  }
}

const consumption_history_repository = new ConsumptionHistoryRepository();

export {
  consumption_history_repository,
};
